Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var isCentred = _ref.isCentred,
    showCommit = _ref.showCommit;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var stepCard = {
    width: '100%',
    flexGrow: 1
  };
  var buttonContainerStyle = {};
  var buttonTextStyle = {};
  if (isCentred || bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    buttonContainerStyle.width = '100%';
  }
  if (showCommit && bp.is([bp.mobile_l, bp.desktop_s])) {
    buttonContainerStyle.flexGrow = 1;
    buttonTextStyle.paddingLeft = spacing.xs;
    buttonTextStyle.paddingRight = spacing.xs;
  }
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_l])) {
    buttonTextStyle.fontSize = _styles.STYLES.fontSize.s;
    buttonTextStyle.lineHeight = _styles.STYLES.lineHeight.s;
  }
  var styles = _reactNative.StyleSheet.create({
    stepCard: stepCard,
    buttonContainerStyle: buttonContainerStyle,
    buttonTextStyle: buttonTextStyle
  });
  return {
    styles: styles
  };
};